module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-detail-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.bak
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.companyName))])]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }, [_vm._v("跟踪记录")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_vm._v("企业设置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [(_vm.activeIndex == 1) ? _c('company') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 7) ? _c('TrackManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 8) ? _c('CompamySetting') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79f85968"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/account/UserCom.vue
// module id = 1757
// module chunks = 9